import inView from './inView'

const MIN_R = 30
const image = new Image()
import youAreHere from '../../../assets/youAreHere.png'
image.src = youAreHere

const YouAreHere = ({ space, dx, dy, xScale, yScale, rScale, context, transform: t, screen }) => {
  const x = dx * t.k + xScale(space.x)
  const y = dy * t.k + yScale(space.y)

  if (t.k >= 3 && !inView({ x, y, screen })) {
    return
  }

  const maxR = Math.max(50, rScale(space.w / 2))
  let r = t.k * rScale(space.w / 2)

  if (r < MIN_R) {
    r = MIN_R
  } else if (r > maxR) {
    r = maxR
  }

  context.drawImage(image, x - r, y - r, r * 2, r * 2)
}

export default YouAreHere
